import { useState, useEffect } from "react"

import { Card, Space, Typography, Flex } from "antd"

import { getBulkOrderById } from "@/http/bulkOrder"

import classes from "./BulkOrderState.module.scss"

import { BulkOrderStatus } from "@/types/IBulkOrder"
import { TimerType } from "@/types/ITimer"


const { Text } = Typography

export interface IBulkOrderTimerProps {
  id: number
  type: TimerType
  status: BulkOrderStatus
  start: string
  duration: number
  onExpire?: () => void
  textColor?: string
}

export const BulkOrderTimer = (props: IBulkOrderTimerProps) => {
  const {
    id,
    type,
    status,
    start,
    duration,
    textColor
  } = props

  const [timerText, setTimerText] = useState<string>("")
  const [startTimer, setStartTimer] = useState<string>(start)
  const [durationTimer, setDurationTimer] = useState<number>(duration)

  useEffect(() => {

    const date = new Date()
    const diffInMs = Math.abs(date.getTime() - new Date(startTimer).getTime())
    const diffInSeconds = Math.floor(diffInMs / 1000)

    startCountdown(durationTimer - diffInSeconds)
  }, [startTimer, durationTimer])

  const getDescription = () => {
    if (status === BulkOrderStatus.InProcess) {
      return "Будет рассмотрено"
    } else if (status === BulkOrderStatus.CurrentOffer) {
      return "Предложение действует"
    }
  }

  function startCountdown(durationInSeconds: number) {
    let remainingTime = durationInSeconds

    const intervalId = setInterval(async () => {
        if (remainingTime <= 0) {
            clearInterval(intervalId)
            //Время закончилось

            if (props.onExpire) props.onExpire()

            if (id) {
              const bulkOrder = await getBulkOrderById(id)
              if(bulkOrder.response) {
                switch(type) {
                  case TimerType.BulkOrderAdmin:
                    if (bulkOrder.response.timerAdminStart && bulkOrder.response.timerAdminDuration) {
                      setStartTimer(bulkOrder.response.timerAdminStart)
                      setDurationTimer(bulkOrder.response.timerAdminDuration)
                    }
                    break
                  case TimerType.BulkOrderCustomer:
                    if (bulkOrder.response.timerCustomerStart && bulkOrder.response.timerCustomerDuration) {
                      setStartTimer(bulkOrder.response.timerCustomerStart)
                      setDurationTimer(bulkOrder.response.timerCustomerDuration)
                    }
                    break
                }
              }
            }
            
            return
        }

        const hours = Math.floor(remainingTime / 3600)
        const minutes = Math.floor((remainingTime % 3600) / 60)
        const seconds = remainingTime % 60

        setTimerText(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`)
        remainingTime--
    }, 1000)
  }

  return (
    <Flex vertical={true} align="center" style={{ width: "max-content" }}>
      {timerText !== "" && (
        <>
        <Text style={{ color: textColor ?? "" }}>{getDescription()}</Text>
        <Text style={{ color: textColor ?? "" }}>{timerText}</Text>
        </>
      )}
    </Flex>
  )
}

export default BulkOrderTimer
